import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=12867c7c&"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12867c7c')) {
      api.createRecord('12867c7c', component.options)
    } else {
      api.reload('12867c7c', component.options)
    }
    module.hot.accept("./ConfirmDeleteModal.vue?vue&type=template&id=12867c7c&", function () {
      api.rerender('12867c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/modal/ConfirmDeleteModal.vue"
export default component.exports